import { render, staticRenderFns } from "./BasePassword.vue?vue&type=template&id=9afec482&scoped=true"
import script from "./BasePassword.vue?vue&type=script&lang=js"
export * from "./BasePassword.vue?vue&type=script&lang=js"
import style0 from "./BasePassword.vue?vue&type=style&index=0&id=9afec482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afec482",
  null
  
)

export default component.exports